import { render, staticRenderFns } from "./_EditorProfiles.vue?vue&type=template&id=8f0a5ca0&"
import script from "./_EditorProfiles.vue?vue&type=script&lang=ts&"
export * from "./_EditorProfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports